<template>
  <b-container>
    <div class="bounced-view view"></div>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";

import {
  CHECK_MEETING_FOR_VLAN,
  CREATE_SESSION,
  GET_AUTHENTICATION_ZONE_BY_LOCATION,
  GET_TEMPLATE_METHOD_VARIABLES,
  APPLY_TITLE,
  GET_ENTITY
} from "@/store/actions.type";

export default {
  name: "Bounce",
  computed: {
    ...mapGetters(["session", "authenticationZone", "templateVariables"])
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    setupBasePage() {
      if (this.templateVariables["location_name_override"]) {
        if (this.templateVariables["templateVariables"]["value"]) {
          this.$store.dispatch(
            APPLY_TITLE,
            this.templateVariables["templateVariables"]["value"]
          );
        }
      }
    },
    getTemplateMethodVariables(zone_id) {
      this.$store
        .dispatch(GET_TEMPLATE_METHOD_VARIABLES, {
          zone_id: zone_id
        })
        .then(res => {
          this.setupBasePage();
        });
    },
    getAuthenticationZoneByLocation() {
      let payload = {};
      if (this.$route.query.location_id) {
        payload.location_id = this.$route.query.location_id;
      }
      if (this.$route.query.zone_id) {
        payload.zone_id = this.$route.query.zone_id;
      }
      if (this.$route.query.ssid) {
        payload.ssid = this.$route.query.ssid;
      }
      return this.$store.dispatch(GET_AUTHENTICATION_ZONE_BY_LOCATION, payload);
    },
    checkForVlan() {
      if (this.$route.query.vlan && this.$route.query.location_id) {
        let vlan = this.$route.query.vlan;
        let location_id = this.$route.query.location_id;
        let session_id = this.session.session_id;
        this.$store
          .dispatch(CHECK_MEETING_FOR_VLAN, {
            session_id: session_id
          })
          .then(res => {
            let currentMeeting = res.data;
            if (currentMeeting) {
              let meeting_id = currentMeeting.iId;
              this.$router.push({
                name: "Meeting",
                params: { id: meeting_id }
              });
            }
          });
      }
    },
    createSession() {
      let queryParams = this.$route.query ? this.$route.query : [];
      this.$store
        .dispatch(CREATE_SESSION, {
          query_params: queryParams
        })
        .then(res => {
          this.getAuthenticationZoneByLocation().then(res => {
            let zone_id = res.id;
            this.getTemplateMethodVariables(zone_id);
            // Check for a vlan
            this.checkForVlan();
          });
        });

      // Retrieve the entity by location
      if (this.$route.query.location_id) {
        this.$store.dispatch(GET_ENTITY, {
          location_id: this.$route.query.location_id
        });
      }
    }
  },
  mounted() {
    //this.checkForVlan();
    // Attempt to create a session
    this.createSession();
  }
};
</script>

<style scoped></style>
